import { createSelector } from '@ngrx/store';
import { AppState } from '@app/store/state';
import * as fromAuth from '../reducers/';
import { User } from '@modules/auth/interfaces';

export const selectAuthState = (state: AppState): fromAuth.AuthState => state.auth;

export const selectUser = createSelector(selectAuthState, fromAuth.getUser);

export const selectUserScope = createSelector(selectAuthState, fromAuth.getUserScope);

export const selectUserType = createSelector(selectUserScope, (userScope: User) => {
    return userScope.userType;
});

export const selectUserName = createSelector(selectUserScope, (userScope: User) => {
    return userScope.name;
});

export const selectUserCities = createSelector(selectUserScope, (userScope: User) => {
    return userScope.cities.map((city) => ({ name: city }));
});

export const selectAccessToken = createSelector(selectAuthState, fromAuth.getAccessToken);

export const selectClientConfig = createSelector(selectAuthState, fromAuth.getClientConfig);

export const selectAvailableProviders = createSelector(selectClientConfig, (config: any) => {
    return Object.keys(config.stakeholders);
});

export const selectProviderContactInfos = createSelector(selectClientConfig, (config: any) => {
    return Object.values(config.stakeholders);
});

export const selectAuthenticationLoading = createSelector(selectAuthState, fromAuth.getAuthenticationLoading);

export const selectAuthenticationLoaded = createSelector(selectAuthState, fromAuth.getAuthenticationLoaded);

export const selectLoginFailed = createSelector(selectAuthState, fromAuth.getLoginFailed);
